
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cguzDnbzcbGaqtpiqTp2I6QDd9F0votI_Yh2jrBE49omD0Meta } from "/usr/src/app/src/pages/cgu.vue?macro=true";
import { default as testf6alZWJwtVhu4dQAjdFQ3COu54VTHGOOKYUyw_2D0oQMeta } from "/usr/src/app/src/pages/test.vue?macro=true";
import { default as indexuBsWoMeQ_d8w8D_L0Mwo6zTf3WU5Dl_45g89Px0TrLqQQMeta } from "/usr/src/app/src/pages/index.vue?macro=true";
import { default as resetvhbfnhXvTkL73FjceSpIHBIRbvLFZT7f8EEGLNIVHnYMeta } from "/usr/src/app/src/pages/reset.vue?macro=true";
import { default as logoutjBsocqGRIMV0OnbMeB0Ugi669gd5a3wbqNn1ZXxHq9oMeta } from "/usr/src/app/src/pages/logout.vue?macro=true";
import { default as signinFVXsFVFXFLfNTBe_JGitDJIJtLpmFC3hCJjYwPhl1FUMeta } from "/usr/src/app/src/pages/signin.vue?macro=true";
import { default as switchYZ6v_45_45Wd_4FVmY7OonasddGwq5Y7YvHqtBJSgeoNxG4Meta } from "/usr/src/app/src/pages/switch.vue?macro=true";
import { default as tropheesUfZIEcLElPDh8cbxIefmMmRQ_45J0aKRCi6mMswfBkHwEMeta } from "/usr/src/app/src/pages/trophees.vue?macro=true";
import { default as bienvenuelB3LkpHY7_oYcGx1VWpU9kiiBevDHL0uXa2FcJOIEEIMeta } from "/usr/src/app/src/pages/bienvenue.vue?macro=true";
import { default as viewerbdUmVdPFZV7FR3kVhSunm7mNlJhYWRPH0r4952DX93UMeta } from "/usr/src/app/src/pages/pdf/viewer.vue?macro=true";
import { default as disconnected6jQEAoGlWSTWhr2zE8RjFc_cOhZd6Zpr8Gu_unGVkWIMeta } from "/usr/src/app/src/pages/disconnected.vue?macro=true";
import { default as indexTjvS_45qrlEk7uVoBK9x0L2LCdpFfUI8S3B_93I28Xl1EMeta } from "/usr/src/app/src/pages/gaming/index.vue?macro=true";
import { default as installationgfiTYxFJJMe7jTGxmBHnNl_45QdqIEnKT54rDVquLh9vIMeta } from "/usr/src/app/src/pages/installation.vue?macro=true";
import { default as email4TrMbg0qGl07X5IhboAkyz9WdAEjvZm35l_wGeiHY1wMeta } from "/usr/src/app/src/pages/signup/email.vue?macro=true";
import { default as index6ym79lcN3VF_M4MpnpAWRVcYr5Zl2hOkzgZRbChXLvcMeta } from "/usr/src/app/src/pages/signup/index.vue?macro=true";
import { default as utilisateursVb_x0LU7vuuYcHeAdHdvtcQ5h9HwoId33RLaV7AGooAMeta } from "/usr/src/app/src/pages/utilisateurs.vue?macro=true";
import { default as indexS6qtvxLpPIhb5Mwg962y7apbc5OZMDDBr9SooMtvA9sMeta } from "/usr/src/app/src/pages/famille/index.vue?macro=true";
import { default as _design_systemzHdLwywiwQOi_45_5aeYwpvpCDCGhgS7HZBBlez11vEYoMeta } from "/usr/src/app/src/pages/_design_system.vue?macro=true";
import { default as index2FhdNzCNIyNrjOAzo5RauHES0J7j87n8mDIiAIId_VkMeta } from "/usr/src/app/src/pages/mes-amis/index.vue?macro=true";
import { default as indexygVMv5J2bk9OaeJY1utVTIeDYx95Z9m7r9jly1dhsmsMeta } from "/usr/src/app/src/pages/redirect/index.vue?macro=true";
import { default as indexvMeduYA7XJlpvcvB_45_45FF9jFwjCL32ikUOS49Qjs1xGwMeta } from "/usr/src/app/src/pages/[section]/index.vue?macro=true";
import { default as forgot_45passwordTdic0M64_457qcsDmvMeSSvDrYk1_C3bsDztE5kuuLqmwMeta } from "/usr/src/app/src/pages/forgot-password.vue?macro=true";
import { default as index_YG_45i35YLH51Gscy3ZVr8Yxfl790vOh1moX_45svTg7AYMeta } from "/usr/src/app/src/pages/profiling/index.vue?macro=true";
import { default as indexmtRVfZMi3BpdKfM32209_VSP7xGSwHvPfnOESwOWRQoMeta } from "/usr/src/app/src/pages/challenges/index.vue?macro=true";
import { default as indexEgPHz24NsX2XStocgpEqIpVylDfsNCJXVwqFiCLBJX4Meta } from "/usr/src/app/src/pages/mon-compte/index.vue?macro=true";
import { default as _91_46_46_46slugs_93pTcLC0W72iw3qGpC2FdnabjhXQQG93VwgyIZP7goh0YMeta } from "/usr/src/app/src/pages/nomad/[...slugs].vue?macro=true";
import { default as _91slug_93W_45McJWizpl8kxDsSrzdFjzz8XFXXpEasHn23mNJjw6QMeta } from "/usr/src/app/src/pages/challenges/[slug].vue?macro=true";
import { default as by_45stepBEDvWBl2ktQX5Qt9KlnlMvyW_45HOrk0sUSGgw2peXJ9kMeta } from "/usr/src/app/src/pages/profiling/by-step.vue?macro=true";
import { default as _91token_93EWOYlqTxoDGFpovJHm0U8KolzoLguS_45HiPNqk641DacMeta } from "/usr/src/app/src/pages/tokenauth/[token].vue?macro=true";
import { default as indexApwCAia1a7BPQp6o_hG5Vzf5o7rlSB622CHppEm6NHoMeta } from "/usr/src/app/src/pages/depatouiller/index.vue?macro=true";
import { default as rechercheY28Jh1OYXzmzm6UfNhENNNMOOWx_qn_Q51YUJYsGL4cMeta } from "/usr/src/app/src/pages/mes-amis/recherche.vue?macro=true";
import { default as decouverteRHPqMMimFD4ajGkynI48OCxmPYBa2FMft2R_E2I1_hUMeta } from "/usr/src/app/src/pages/mes-amis/decouverte.vue?macro=true";
import { default as indexhLoayvvoR__lxsrNBvuHKQ9Lfaw_45b4ottOBKqW88Tm8Meta } from "/usr/src/app/src/pages/famille/[name]/index.vue?macro=true";
import { default as presentationdzZ_05i9ER2D0Bq_PyfYJeZvxnRWiwEP6j3n0yg9gAkMeta } from "/usr/src/app/src/pages/famille/presentation.vue?macro=true";
import { default as ajouter_45xsZvFnvT39ECUMLbnYHKGP8YK_4533eTkZ4gX3dUFH_45cMeta } from "/usr/src/app/src/pages/[section]/eval/ajouter.vue?macro=true";
import { default as quiz_45du_45jourztuf3PA3nB9OkYqaCBRETsbqEnJ4Ge8QADR9WaHgAzUMeta } from "/usr/src/app/src/pages/[section]/quiz-du-jour.vue?macro=true";
import { default as deeplinkss8ETkO2qrolZudmPkG6eVyw4msttQZP0ziLvExYQZBEMeta } from "/usr/src/app/src/pages/depatouiller/deeplinks.vue?macro=true";
import { default as indexESuDgFGZR7bhfSMLIWZSJmeFPuRuhvM5Z_qfzPF_JccMeta } from "/usr/src/app/src/pages/mes-statistiques/index.vue?macro=true";
import { default as _91_46_46_46slugs_93BIJvhjN1FB731ADjUllXTaKapvoZO_45SdXm_455QfNciHkMeta } from "/usr/src/app/src/pages/orientation/[...slugs].vue?macro=true";
import { default as informationsd_1HigGh3_czGZPoQiaIeblbCdFMYXOZqeKbRbQYxVAMeta } from "/usr/src/app/src/pages/profiling/informations.vue?macro=true";
import { default as testDM1SJygo2Fqc2nCxL_45QpWcdqsG5nEQsMjHuiv4P9dV8Meta } from "/usr/src/app/src/pages/[section]/recherche/test.js?macro=true";
import { default as index29Ts__8fUUgXwHeZ_dIkSuk0oGXFK6JX_45g4H0icKeqIMeta } from "/usr/src/app/src/pages/gaming/challenges/index.vue?macro=true";
import { default as indexajedmatkGzkUIzFJiRiARVmjQgFBXaihZSqMT1rH0coMeta } from "/usr/src/app/src/pages/[section]/recherche/index.vue?macro=true";
import { default as index1i6gWtlMN1B14__45RUiOs_45Hfz_Jb5QkSWyETd7Cgvtl4Meta } from "/usr/src/app/src/pages/mes-amis/[friendId]/index.vue?macro=true";
import { default as cahier_45de_45vacancesi2Ez6h7Z0Z15ovO5rm_3pjouB2s_gv8iN2YZ6L3o9hoMeta } from "/usr/src/app/src/pages/famille/cahier-de-vacances.vue?macro=true";
import { default as userBBM4AJ1PGAmDmYRVcjLm9yZ0deTXr4dwmmZbLoyEi5kMeta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/user.vue?macro=true";
import { default as index_vcuR5ADSYpAgnmyG9N_nisQS1wVHrxDlB9OGY5O5KEMeta } from "/usr/src/app/src/pages/mes-statistiques/[lb]/index.vue?macro=true";
import { default as indexgpUTA6poWDe5n6sUKqXORBESd_2LUdGr0PH2HK6s3ecMeta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/index.vue?macro=true";
import { default as ajouter_45un_45membre5ALH98dzJUtYB_E7Vn0takRTk2YR51_M7rXlXFb_45M3oMeta } from "/usr/src/app/src/pages/mon-compte/ajouter-un-membre.vue?macro=true";
import { default as index9xxgFw94ObWllUk3XmdwvSHkg_EMBEBFRR66F9feKNsMeta } from "/usr/src/app/src/pages/gaming/challenges/[slug]/index.vue?macro=true";
import { default as modifier_45mon_45profilMioSlfr1gTz_a5wkiOGcuMfXX1vIECzM0uvVnxJBhmEMeta } from "/usr/src/app/src/pages/mon-compte/modifier-mon-profil.vue?macro=true";
import { default as exercice7z4yY8Hoblu_9a9munQBxZu2GhlRBB6FHtldDt0WJeEMeta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/exercice.vue?macro=true";
import { default as ajouter_45premier_45membreQek736kx2raSBf_iRRO_45m6C6RJCrkksEkLdYin_45YtawMeta } from "/usr/src/app/src/pages/mon-compte/ajouter-premier-membre.vue?macro=true";
import { default as _91id_93kItc9VQn9msheN8TN8zcqCLJCPtt0P7SoGxSwW8bQPUMeta } from "/usr/src/app/src/pages/[section]/simulateur-de-notes/[id].vue?macro=true";
import { default as _91id_93IfbmZAUag5fn7E9CHpo51tGSAeyGue4g89DaTTfx9ZwMeta } from "/usr/src/app/src/pages/mon-compte/modifier-un-membre/[id].vue?macro=true";
import { default as indexaksrjXfphqIjYTnLczaMVSpoLmJ5TnLYxvpLLCujk5EMeta } from "/usr/src/app/src/pages/[section]/simulateur-de-notes/index.vue?macro=true";
import { default as modifier_45mes_45informationsppDPJ1REogeg43hkKtDJZrx0avwJYbaGLOK6rXc72VEMeta } from "/usr/src/app/src/pages/mon-compte/modifier-mes-informations.vue?macro=true";
import { default as indexlHGmj3dEn23BUJud6t3CGgQbvaA5NbUUAB_WHIRNWq0Meta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/index.vue?macro=true";
import { default as indexGpgbbIaJExlVFA6xlQT0ywPY5fzjN2pRWuBpH7zOJ3gMeta } from "/usr/src/app/src/pages/mes-amis/[friendId]/amis-en-commun/index.vue?macro=true";
import { default as _91post_93hsmgVGGbpah3jCCx6uEY6_0Z4xkkFWp7ndrTYq74qpYMeta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/post/[post].vue?macro=true";
import { default as _91exercise_933J46eaEBYMxcw_YgEd4sL0j7B_67d6XLKKqqQ_45RZsW0Meta } from "/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/exercise/[exercise].vue?macro=true";
export default [
  {
    name: "cgu",
    path: "/cgu",
    meta: cguzDnbzcbGaqtpiqTp2I6QDd9F0votI_Yh2jrBE49omD0Meta || {},
    component: () => import("/usr/src/app/src/pages/cgu.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/usr/src/app/src/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["parent-redirect-adventure","parent-redirect-firstchild","marine-redirect-welcome"]},
    component: () => import("/usr/src/app/src/pages/index.vue")
  },
  {
    name: "reset",
    path: "/reset",
    meta: resetvhbfnhXvTkL73FjceSpIHBIRbvLFZT7f8EEGLNIVHnYMeta || {},
    component: () => import("/usr/src/app/src/pages/reset.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutjBsocqGRIMV0OnbMeB0Ugi669gd5a3wbqNn1ZXxHq9oMeta || {},
    component: () => import("/usr/src/app/src/pages/logout.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinFVXsFVFXFLfNTBe_JGitDJIJtLpmFC3hCJjYwPhl1FUMeta || {},
    component: () => import("/usr/src/app/src/pages/signin.vue")
  },
  {
    name: "switch",
    path: "/switch",
    meta: switchYZ6v_45_45Wd_4FVmY7OonasddGwq5Y7YvHqtBJSgeoNxG4Meta || {},
    component: () => import("/usr/src/app/src/pages/switch.vue")
  },
  {
    name: "trophees",
    path: "/trophees",
    component: () => import("/usr/src/app/src/pages/trophees.vue")
  },
  {
    name: "bienvenue",
    path: "/bienvenue",
    component: () => import("/usr/src/app/src/pages/bienvenue.vue")
  },
  {
    name: "pdf-viewer",
    path: "/pdf/viewer",
    meta: viewerbdUmVdPFZV7FR3kVhSunm7mNlJhYWRPH0r4952DX93UMeta || {},
    component: () => import("/usr/src/app/src/pages/pdf/viewer.vue")
  },
  {
    name: "disconnected",
    path: "/disconnected",
    meta: disconnected6jQEAoGlWSTWhr2zE8RjFc_cOhZd6Zpr8Gu_unGVkWIMeta || {},
    component: () => import("/usr/src/app/src/pages/disconnected.vue")
  },
  {
    name: "gaming",
    path: "/gaming",
    meta: {"middleware":["parent-redirect-home"]},
    component: () => import("/usr/src/app/src/pages/gaming/index.vue")
  },
  {
    name: "installation",
    path: "/installation",
    meta: installationgfiTYxFJJMe7jTGxmBHnNl_45QdqIEnKT54rDVquLh9vIMeta || {},
    component: () => import("/usr/src/app/src/pages/installation.vue")
  },
  {
    name: "signup-email",
    path: "/signup/email",
    meta: email4TrMbg0qGl07X5IhboAkyz9WdAEjvZm35l_wGeiHY1wMeta || {},
    component: () => import("/usr/src/app/src/pages/signup/email.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: index6ym79lcN3VF_M4MpnpAWRVcYr5Zl2hOkzgZRbChXLvcMeta || {},
    component: () => import("/usr/src/app/src/pages/signup/index.vue")
  },
  {
    name: "utilisateurs",
    path: "/utilisateurs",
    meta: utilisateursVb_x0LU7vuuYcHeAdHdvtcQ5h9HwoId33RLaV7AGooAMeta || {},
    component: () => import("/usr/src/app/src/pages/utilisateurs.vue")
  },
  {
    name: "famille",
    path: "/famille",
    component: () => import("/usr/src/app/src/pages/famille/index.vue")
  },
  {
    name: "_design_system",
    path: "/_design_system",
    component: () => import("/usr/src/app/src/pages/_design_system.vue")
  },
  {
    name: "mes-amis",
    path: "/mes-amis",
    component: () => import("/usr/src/app/src/pages/mes-amis/index.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/usr/src/app/src/pages/redirect/index.vue")
  },
  {
    name: "section",
    path: "/:section()",
    meta: indexvMeduYA7XJlpvcvB_45_45FF9jFwjCL32ikUOS49Qjs1xGwMeta || {},
    component: () => import("/usr/src/app/src/pages/[section]/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordTdic0M64_457qcsDmvMeSSvDrYk1_C3bsDztE5kuuLqmwMeta || {},
    component: () => import("/usr/src/app/src/pages/forgot-password.vue")
  },
  {
    name: "profiling",
    path: "/profiling",
    meta: index_YG_45i35YLH51Gscy3ZVr8Yxfl790vOh1moX_45svTg7AYMeta || {},
    component: () => import("/usr/src/app/src/pages/profiling/index.vue")
  },
  {
    name: "challenges",
    path: "/challenges",
    component: () => import("/usr/src/app/src/pages/challenges/index.vue")
  },
  {
    name: "mon-compte",
    path: "/mon-compte",
    component: () => import("/usr/src/app/src/pages/mon-compte/index.vue")
  },
  {
    name: "nomad-slugs",
    path: "/nomad/:slugs(.*)*",
    meta: _91_46_46_46slugs_93pTcLC0W72iw3qGpC2FdnabjhXQQG93VwgyIZP7goh0YMeta || {},
    component: () => import("/usr/src/app/src/pages/nomad/[...slugs].vue")
  },
  {
    name: "challenges-slug",
    path: "/challenges/:slug()",
    component: () => import("/usr/src/app/src/pages/challenges/[slug].vue")
  },
  {
    name: "profiling-by-step",
    path: "/profiling/by-step",
    meta: by_45stepBEDvWBl2ktQX5Qt9KlnlMvyW_45HOrk0sUSGgw2peXJ9kMeta || {},
    component: () => import("/usr/src/app/src/pages/profiling/by-step.vue")
  },
  {
    name: "tokenauth-token",
    path: "/tokenauth/:token()",
    meta: _91token_93EWOYlqTxoDGFpovJHm0U8KolzoLguS_45HiPNqk641DacMeta || {},
    component: () => import("/usr/src/app/src/pages/tokenauth/[token].vue")
  },
  {
    name: "depatouiller",
    path: "/depatouiller",
    meta: {"middleware":["debug-redirect-home"]},
    component: () => import("/usr/src/app/src/pages/depatouiller/index.vue")
  },
  {
    name: "mes-amis-recherche",
    path: "/mes-amis/recherche",
    component: () => import("/usr/src/app/src/pages/mes-amis/recherche.vue")
  },
  {
    name: "mes-amis-decouverte",
    path: "/mes-amis/decouverte",
    component: () => import("/usr/src/app/src/pages/mes-amis/decouverte.vue")
  },
  {
    name: "famille-name",
    path: "/famille/:name()",
    component: () => import("/usr/src/app/src/pages/famille/[name]/index.vue")
  },
  {
    name: "famille-presentation",
    path: "/famille/presentation",
    component: () => import("/usr/src/app/src/pages/famille/presentation.vue")
  },
  {
    name: "section-eval-ajouter",
    path: "/:section()/eval/ajouter",
    meta: ajouter_45xsZvFnvT39ECUMLbnYHKGP8YK_4533eTkZ4gX3dUFH_45cMeta || {},
    component: () => import("/usr/src/app/src/pages/[section]/eval/ajouter.vue")
  },
  {
    name: "section-quiz-du-jour",
    path: "/:section()/quiz-du-jour",
    meta: {"middleware":["featureflag-redirect-dailyquiz"]},
    component: () => import("/usr/src/app/src/pages/[section]/quiz-du-jour.vue")
  },
  {
    name: "depatouiller-deeplinks",
    path: "/depatouiller/deeplinks",
    component: () => import("/usr/src/app/src/pages/depatouiller/deeplinks.vue")
  },
  {
    name: "mes-statistiques",
    path: "/mes-statistiques",
    component: () => import("/usr/src/app/src/pages/mes-statistiques/index.vue")
  },
  {
    name: "orientation-slugs",
    path: "/orientation/:slugs(.*)*",
    component: () => import("/usr/src/app/src/pages/orientation/[...slugs].vue")
  },
  {
    name: "profiling-informations",
    path: "/profiling/informations",
    meta: informationsd_1HigGh3_czGZPoQiaIeblbCdFMYXOZqeKbRbQYxVAMeta || {},
    component: () => import("/usr/src/app/src/pages/profiling/informations.vue")
  },
  {
    name: "section-recherche-test",
    path: "/:section()/recherche/test",
    component: () => import("/usr/src/app/src/pages/[section]/recherche/test.js")
  },
  {
    name: "gaming-challenges",
    path: "/gaming/challenges",
    component: () => import("/usr/src/app/src/pages/gaming/challenges/index.vue")
  },
  {
    name: "section-recherche",
    path: "/:section()/recherche",
    component: () => import("/usr/src/app/src/pages/[section]/recherche/index.vue")
  },
  {
    name: "mes-amis-friendId",
    path: "/mes-amis/:friendId()",
    component: () => import("/usr/src/app/src/pages/mes-amis/[friendId]/index.vue")
  },
  {
    name: "famille-cahier-de-vacances",
    path: "/famille/cahier-de-vacances",
    component: () => import("/usr/src/app/src/pages/famille/cahier-de-vacances.vue")
  },
  {
    name: "section-lb_or_eval-user",
    path: "/:section()/:lb_or_eval()/user",
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/user.vue")
  },
  {
    name: "mes-statistiques-lb",
    path: "/mes-statistiques/:lb()",
    component: () => import("/usr/src/app/src/pages/mes-statistiques/[lb]/index.vue")
  },
  {
    name: "section-lb_or_eval",
    path: "/:section()/:lb_or_eval()",
    meta: {"middleware":["marine-redirect-welcome"]},
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/index.vue")
  },
  {
    name: "mon-compte-ajouter-un-membre",
    path: "/mon-compte/ajouter-un-membre",
    component: () => import("/usr/src/app/src/pages/mon-compte/ajouter-un-membre.vue")
  },
  {
    name: "gaming-challenges-slug",
    path: "/gaming/challenges/:slug()",
    meta: {"middleware":["parent-redirect-home"]},
    component: () => import("/usr/src/app/src/pages/gaming/challenges/[slug]/index.vue")
  },
  {
    name: "mon-compte-modifier-mon-profil",
    path: "/mon-compte/modifier-mon-profil",
    meta: modifier_45mon_45profilMioSlfr1gTz_a5wkiOGcuMfXX1vIECzM0uvVnxJBhmEMeta || {},
    component: () => import("/usr/src/app/src/pages/mon-compte/modifier-mon-profil.vue")
  },
  {
    name: "section-lb_or_eval-exercice",
    path: "/:section()/:lb_or_eval()/exercice",
    meta: exercice7z4yY8Hoblu_9a9munQBxZu2GhlRBB6FHtldDt0WJeEMeta || {},
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/exercice.vue")
  },
  {
    name: "mon-compte-ajouter-premier-membre",
    path: "/mon-compte/ajouter-premier-membre",
    component: () => import("/usr/src/app/src/pages/mon-compte/ajouter-premier-membre.vue")
  },
  {
    name: "section-simulateur-de-notes-id",
    path: "/:section()/simulateur-de-notes/:id()",
    meta: {"middleware":["parent-redirect-home","featureflag-redirect-gradesimulator"]},
    component: () => import("/usr/src/app/src/pages/[section]/simulateur-de-notes/[id].vue")
  },
  {
    name: "mon-compte-modifier-un-membre-id",
    path: "/mon-compte/modifier-un-membre/:id()",
    component: () => import("/usr/src/app/src/pages/mon-compte/modifier-un-membre/[id].vue")
  },
  {
    name: "section-simulateur-de-notes",
    path: "/:section()/simulateur-de-notes",
    meta: {"middleware":["parent-redirect-home","featureflag-redirect-gradesimulator"]},
    component: () => import("/usr/src/app/src/pages/[section]/simulateur-de-notes/index.vue")
  },
  {
    name: "mon-compte-modifier-mes-informations",
    path: "/mon-compte/modifier-mes-informations",
    meta: modifier_45mes_45informationsppDPJ1REogeg43hkKtDJZrx0avwJYbaGLOK6rXc72VEMeta || {},
    component: () => import("/usr/src/app/src/pages/mon-compte/modifier-mes-informations.vue")
  },
  {
    name: "section-lb_or_eval-category",
    path: "/:section()/:lb_or_eval()/:category()",
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/index.vue")
  },
  {
    name: "mes-amis-friendId-amis-en-commun",
    path: "/mes-amis/:friendId()/amis-en-commun",
    component: () => import("/usr/src/app/src/pages/mes-amis/[friendId]/amis-en-commun/index.vue")
  },
  {
    name: "section-lb_or_eval-category-post-post",
    path: "/:section()/:lb_or_eval()/:category()/post/:post()",
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/post/[post].vue")
  },
  {
    name: "section-lb_or_eval-category-exercise-exercise",
    path: "/:section()/:lb_or_eval()/:category()/exercise/:exercise()",
    component: () => import("/usr/src/app/src/pages/[section]/[lb_or_eval]/[category]/exercise/[exercise].vue")
  }
]